// slice 02.1 · paso b.6c — header sticky de días del canvas de roadmap (`ComponentTaskFlow.jsx`).
// Presentacional puro: recibe `timeline` ya calculado por el container (useMemo), y las 3
// primitivas de posición/zoom (`flowPosX`/`flowScale`) más las 2 etiquetas ya formateadas
// (`activeMonthStr`/`activeWeekStr`) — nunca el objeto `flowPos` crudo completo, ya que este
// header solo necesita el eje X.

export default function FlowGanttHeader({ timeline, flowPosX, flowScale, activeMonthStr, activeWeekStr }) {
    return (
        <div className="op-task-flow-gantt-header">
            {/* Fila 1: Sticky Overlay */}
            <div className="op-task-flow-gantt-sticky-row" style={{ position: 'sticky', left: 0, display: 'flex', gap: '12px', alignItems: 'center', padding: '0 16px', paddingLeft: '35px', height: '30px', backgroundColor: 'rgba(7, 7, 9, 0.95)', zIndex: 10, borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#fff', letterSpacing: '0.5px' }}>{activeMonthStr}</span>
                <span style={{ fontSize: '10px', color: '#888', background: 'rgba(255,255,255,0.1)', padding: '2px 6px', borderRadius: '4px' }}>{activeWeekStr}</span>
                <span style={{ fontSize: '10px', color: '#888', background: 'rgba(255,255,255,0.05)', padding: '2px 6px', borderRadius: '4px' }}>{Math.round(flowScale * 100)}%</span>
            </div>

            <div
                className="op-task-flow-gantt-scroll"
                style={{
                    transform: `translateX(${flowPosX}px) scaleX(${flowScale})`,
                    transformOrigin: '0 0',
                }}
            >
                {/* Days Row */}
                <div className="op-task-flow-gantt-row op-task-flow-gantt-days">
                    {timeline.days.map((d) => (
                        <div key={d.index} className={`op-task-flow-gantt-cell op-task-flow-gantt-day ${d.isToday ? 'is-today' : ''}`} style={{ left: d.index * 200, width: 200, backgroundColor: d.isWeekend ? 'rgba(255,255,255,0.03)' : 'transparent' }}>
                            <div className="op-task-flow-gantt-day-inner" style={{ transform: `scaleX(${1 / flowScale})`, transformOrigin: 'center center', display: 'flex', gap: '4px', flexDirection: 'row' }}>
                                <span className="day-name">{d.dayName}</span>
                                <span className="day-num">{d.dayNum}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
